/*
 *
 * QrCodePopup
 *
 * @version 1.0.0
 * @author Marco Civello
 * @since 16-Jun-2025
 */
import React from 'react'
// import { defineMessages } from 'react-intl'
import PortalMessage from 'Hoc/PortalMessage'

export const messages = {
  title: {
    id: 't.app.payByLink.qrCodePopup.title',
    defaultMessage: 'QR-Code Format'
  },
  description: {
    id: 't.app.payByLink.qrCodePopup.description',
    defaultMessage: 'Select QR Code format'
  },
  closeAriaLabel: {
    id: 't.app.accessibility.project.btn.close.ariaLabel',
    defaultMessage: 'Close'
  },
  download: {
    id: 't.app.payByLink.qrCodePopup.btn.download',
    defaultMessage: 'Download QR Code'
  },
  copy: {
    id: 't.app.payByLink.qrCodePopup.btn.copy',
    defaultMessage: 'Copy QR-Code'
  },
  format: {
    id: 't.app.payByLink.qrCodePopup.select.format',
    defaultMessage: 'Format*'
  },
  size: {
    id: 't.app.payByLink.qrCodePopup.select.size',
    defaultMessage: 'Size*'
  },
  tooltipTitle: {
    id: 't.app.payByLink.qrCodePopup.tooltip.title',
    defaultMessage: 'Choose a QR code size (in pixels) based on intended use:'
  },
  tooltipDescription300: {
    id: 't.app.payByLink.qrCodePopup.tooltip.description.300',
    defaultMessage: '300x300: Digital platforms (e.g., websites, mobile apps);'
  },
  tooltipDescription600: {
    id: 't.app.payByLink.qrCodePopup.tooltip.description.600',
    defaultMessage: '600x600: Point-of-sale materials (e.g., flyers, storefronts, product cards);'
  },
  tooltipDescription1200: {
    id: 't.app.payByLink.qrCodePopup.tooltip.description.1200',
    defaultMessage: '1200x1200: Large-scale advertising (e.g., billboards, banners).'
  },
  mandatoryField: {
    id: 't.app.payByLink.qrCodePopup.mandatoryField',
    defaultMessage: '*Required field'
  },
  copySuccess: {
    id: 't.app.payByLink.toast.copiedQrCode.success',
    defaultMessage: 'QR Code successfully copied'
  },
  downloadSuccess: {
    id: 't.app.payByLink.toast.downloadQrCode.success',
    defaultMessage: 'QR Code successfully downloaded'
  },
  pixels: {
    id: 't.app.payByLink.qrCodePopup.select.pixels',
    defaultMessage: 'pixels'
  },
  remainingCharacters: {
    id: 't.app.moto.request.remainingCharacters',
    defaultMessage: ' remaining characters'
  },
  remainingCharacter: {
    id: 't.app.moto.request.remainingCharacter',
    defaultMessage: ' remaining character'
  },
  blueOnTransparent: {
    id: 't.app.payByLink.qrCodePopup.preview.color.blueOnTransparent',
    defaultMessage: 'Blue on transparent'
  },
  blueOnWhite: {
    id: 't.app.payByLink.qrCodePopup.preview.color.blueOnWhite',
    defaultMessage: 'Blue on white'
  },
  whiteOnBlue: {
    id: 't.app.payByLink.qrCodePopup.preview.color.whiteOnBlue',
    defaultMessage: 'White on blue'
  },
  whiteOnColour: {
    id: 't.app.payByLink.qrCodePopup.preview.color.whiteOnColour',
    defaultMessage: 'White on colour'
  },
  colourOnWhite: {
    id: 't.app.payByLink.qrCodePopup.preview.color.colourOnWhite',
    defaultMessage: 'Colour on white'
  },
  colourOnTransparent: {
    id: 't.app.payByLink.qrCodePopup.preview.color.colourOnTransparent',
    defaultMessage: 'Colour on transparent'
  },
  preview: {
    id: 't.app.payByLink.qrCodePopup.preview.title',
    defaultMessage: 'Preview'
  },
  color: {
    id: 't.app.payByLink.qrCodePopup.color',
    defaultMessage: 'Color'
  },
  shape: {
    id: 't.app.payByLink.qrCodePopup.shape',
    defaultMessage: 'Shape'   
  },
  heart: {
    id: 't.app.payByLink.qrCodePopup.shape.heart',
    defaultMessage: 'Heart'
  },
  bag: {
    id: 't.app.payByLink.qrCodePopup.shape.bag',
    defaultMessage: 'Bag'
  },
  truck: {
    id: 't.app.payByLink.qrCodePopup.shape.truck',
    defaultMessage: 'Truck'
  },
  shopper: {
    id: 't.app.payByLink.qrCodePopup.shape.shopper',
    defaultMessage: 'Shopper'
  },
  chef: {
    id: 't.app.payByLink.qrCodePopup.shape.chef',
    defaultMessage: 'Chef'
  },  
  none: {
    id: 't.app.payByLink.qrCodePopup.shape.none',
    defaultMessage: 'None'
  },
  shapeHelperText: {
    id: 't.app.payByLink.qrCodePopup.helperTextShape',
    defaultMessage: 'Choose the frame shape to apply to the QR code'
  },
  colorHelperText: {
    id: 't.app.payByLink.qrCodePopup.helperTextColor',
    defaultMessage: 'Enter a hexadecimal color or use the color picker'
  },
  editColor: {
    id: 't.app.settings.users.edit',
    defaultMessage: 'Edit'
  },
  frameTextLabel: {
    id: 't.app.payByLink.qrCodePopup.preview.frameText.label',
    defaultMessage: 'Text in frame (optional)'
  },
  actionAriaLabel: {
    id: 't.app.accessibility.moto.request.other.info.action.ariaLabel',
    defaultMessage: 'Action'
  },
}

const formattedMessage = {
  aspect: <PortalMessage id='t.app.payByLink.qrCodePopup.preview.aspect' defaultMessage='Aspect' />,
  aspectDescriptionStandard: <PortalMessage id='t.app.payByLink.qrCodePopup.preview.aspectDescriptionStandard' defaultMessage='Customize the frame and colors of the Shop code' />,
  aspectDescriptionDonaItalia: <PortalMessage id='t.app.payByLink.qrCodePopup.preview.aspectDescriptionDonaItalia' defaultMessage='The heart-shaped frame is included in the customization' />,
  colorsCombination: <PortalMessage id='t.app.payByLink.qrCodePopup.preview.colorsCombination' defaultMessage='Color combination' />,
  colourOnWhite: <PortalMessage id='t.app.payByLink.qrCodePopup.preview.color.colourOnWhite' defaultMessage='Color on white' />,
  whiteOnColour: <PortalMessage id='t.app.payByLink.qrCodePopup.preview.color.whiteOnColour' defaultMessage='White on color' />,
  colourOnTransparent: <PortalMessage id='t.app.payByLink.qrCodePopup.preview.color.colourOnTransparent' defaultMessage='Color on transparent' />,
  blueOnTransparent: <PortalMessage id='t.app.payByLink.qrCodePopup.preview.color.blueOnTransparent' defaultMessage='Blue on transparent' />,
  blueOnWhite: <PortalMessage id='t.app.payByLink.qrCodePopup.preview.color.blueOnWhite' defaultMessage='Blue on white' />,
  whiteOnBlue: <PortalMessage id='t.app.payByLink.qrCodePopup.preview.color.whiteOnBlue' defaultMessage='White on blue' />,
  disclaimerLine1: <PortalMessage id='t.app.payByLink.qrCodePopup.preview.disclaimer.line1' defaultMessage='The Shop code in preview is illustrative.' />,
  disclaimerLine2: <PortalMessage id='t.app.payByLink.qrCodePopup.preview.disclaimer.line2' defaultMessage='The downloaded one will contain the real payment link.' />,
  fileFormatDescription: <PortalMessage id='t.app.payByLink.qrCodePopup.preview.fileFormat.description' defaultMessage='Choose the format and size of the file to download' />,
  fileFormatTitle: <PortalMessage id='t.app.payByLink.qrCodePopup.preview.fileFormat.title' defaultMessage='File format' />,
  frameTextAutoColor: <PortalMessage id='t.app.payByLink.qrCodePopup.preview.frameText.autoColor' defaultMessage='The text color in the frame adapts automatically' />,
  frameTextLabel: <PortalMessage id='t.app.payByLink.qrCodePopup.preview.frameText.label' defaultMessage='Text in frame (optional)' />,
  frameTextMaxLength: <PortalMessage id='t.app.payByLink.qrCodePopup.preview.frameText.maxLength' defaultMessage='Max 10 characters' />,
  legendCombination: <PortalMessage id='t.app.payByLink.qrCodePopup.preview.legend.combination' defaultMessage='Combination' />,
  legendFormat: <PortalMessage id='t.app.payByLink.qrCodePopup.preview.legend.format' defaultMessage='Format' />,
  legendFrame: <PortalMessage id='t.app.payByLink.qrCodePopup.preview.legend.frame' defaultMessage='Frame' />,
  legendSize: <PortalMessage id='t.app.payByLink.qrCodePopup.preview.legend.size' defaultMessage='Size' />,
  resetDefaultValues: <PortalMessage id='t.app.payByLink.qrCodePopup.preview.resetDefaultValues' defaultMessage='Reset default values' />,
  preview: <PortalMessage id='t.app.payByLink.qrCodePopup.preview.title' defaultMessage='Preview' />,
}
export default formattedMessage
